const Vue = require('vue')
const $ = require('jquery')

Vue.component('parsed-sandbox', {
    props: {
        content: {
            required: true
        }
    },
    components: require('./components'),
    data () {
        return {}
    },
    ready () {
        this.bind()
    },
    methods: {
        bind () {
            const $el = $(this.$el).append(this.content)

            this.$compile($el.get(0))
        }
    },
    watch: {},
    template: `<span></span>`
})

Vue.component('parsed', {
    props: {
        name: {
            required: true
        }
    },
    components: require('./components'),
    data () {
        return {}
    },
    ready () {},
    methods: {},
    watch: {},
    template: `<component :is="name"><slot></slot></component>`
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/parsed/index.js